export class DomHelper {
  static showError(container, message) {
    container.innerHTML = `
      <div class="alert alert-danger">
        <i class="fas fa-exclamation-triangle me-2"></i>
        ${message}
      </div>
    `
  }

  static showValidationError(input, feedback, message) {
    input.classList.add('is-invalid')
    input.classList.remove('is-valid')
    if (feedback) {
      feedback.textContent = message
      feedback.style.display = 'block'
    }
  }

  static showValidationSuccess(input, feedback) {
    input.classList.remove('is-invalid')
    input.classList.add('is-valid')
    if (feedback) {
      feedback.textContent = ''
      feedback.style.display = 'none'
    }
  }

  static clearValidation(input, feedback) {
    input.classList.remove('is-invalid', 'is-valid')
    if (feedback) {
      feedback.textContent = ''
      feedback.style.display = 'none'
    }
  }

  static formatDateTime(dateTime, locale = 'ja-JP') {
    return new Date(dateTime).toLocaleString(locale)
  }

  static padTime(value) {
    return String(value).padStart(2, '0')
  }
}